'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
/*
 * Prefixes URLs without protocol with the same protocl
 * as the app. In production this will be always https,
 * during development this can be changed to the
 * unsecure http version.
 */
var ensureProtocol = exports.ensureProtocol = function ensureProtocol(url) {
  var useSSL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : process.env.HTTPS;

  if (!url || url.startsWith('http')) return url;
  var protocol = useSSL ? 'https' : 'http';
  var filler = '://';
  return protocol + filler + url;
};

/*
 * Returns a direct url to the icon picture.
 *
 * @param {String | Object} icon If the user didn't upload a custom picture string,
 *   we are able to construct a precise url from the picture schema object.
 * @param {Integer} size Requested resource size.
 */
var getIconUrl = exports.getIconUrl = function getIconUrl(icon, size) {
  if (!icon) return '';
  if (typeof icon === 'string') return icon;
  if (icon.suffix.endsWith('svg')) return icon.prefix + icon.suffix;
  size = size || 64;
  return '' + icon.prefix + size + 'x' + size + '/' + icon.suffix;
};

var sleep = exports.sleep = function sleep() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise(function (resolve) {
    return setTimeout(resolve, delay);
  });
};